import TextField from 'components/FormElements/AppTextInput';
import Autocomplete from 'components/FormElements/AppAutocomplete';
import FieldRow from 'components/FormElements/FieldRow';
import RecordView from 'components/RecordView';
import { Api as CompaniesApi } from 'further-types/companies';

const StageAndSector = ({ errorText, setValues, values, disabled = false }) => {
  return (
    <RecordView size="full">
      <FieldRow title="Stage*" centerTitle>
        <Autocomplete
          disabled={disabled}
          id="stageAutocomplete"
          getOptionKey={(option) => option}
          options={['', ...Object.values(CompaniesApi.Stage)]}
          filterSelectedOptions
          onChange={(_event, stage) => {
            setValues({ ...values, stage });
          }}
          value={values.stage}
          renderInput={(params) => (
            <TextField
              {...params}
              required
              name="stage"
              placeholder="Select stage"
              fullWidth
              error={errorText.stage}
              helperText={errorText.stage}
            />
          )}
        />
      </FieldRow>
      <FieldRow title="Sector*" centerTitle>
        <Autocomplete
          disabled={disabled}
          id="sectorAutocomplete"
          getOptionKey={(option) => option}
          options={['', ...Object.values(CompaniesApi.Sector)]}
          filterSelectedOptions
          onChange={(_event, sector) => {
            setValues({ ...values, sector });
          }}
          value={values.sector}
          renderInput={(params) => (
            <TextField
              {...params}
              required
              name="sector"
              placeholder="Select sector"
              fullWidth
              error={errorText.sector}
              helperText={errorText.sector}
            />
          )}
        />
      </FieldRow>
    </RecordView>
  );
};

export default StageAndSector;
